
/**
 * 资质状态枚举
 * @param status
 * @returns {string}
 */
export function getStatusView(status) {
    if (status === 0){
        return '待提交';
    }else if (status === 1){
        return '材料审核中';
    }else if (status === 2){
        return '受理中'
    }else if (status === 3){
        return '待提交联席工作小组审核'
    }else if (status === 4){
        return '联席工作小组审核中'
    }else if (status === 5){
        return '已通过'
    }else if (status === -1){
        return '材料初审未通过'
    }else if (status === -5){
        return '联席工作小组审核未通过'
    }else {
        return '资质已失效'
    }
}

export function getSecurityUserTypeClass(status)  {
    switch(status) {
        case 'driver': return '驾驶员';
        case 'security': return '安全员';
        default: return '安全员';
    }
}